// Local-storage backed persistence for TBI assessments.
//
// DEMO ONLY — this is intentionally client-side so we can present the surface
// without waiting on a real /api/assessments table. Each saved assessment
// carries its org_id, so switching orgs in the shell isolates the list.
//
// When this graduates from demo to shipped:
//   * Move to a Supabase `assessments` table (RLS on org_id + patient_id).
//   * Mirror this module's signature on top of /lib/api.js calls.
//   * Migrate any local-storage records into the table for existing demos.

const KEY = 'medilink:tbi-assessments:v1';

function readAll() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

function writeAll(list) {
  localStorage.setItem(KEY, JSON.stringify(list));
}

function newId() {
  // Crockford-ish short ID — enough entropy for demo cardinality.
  return 'asm_' + Math.random().toString(36).slice(2, 10) + Date.now().toString(36).slice(-4);
}

export function listAssessments(orgId) {
  if (!orgId) return [];
  return readAll()
    .filter(a => a.org_id === orgId)
    .sort((a, b) => new Date(b.completed_at) - new Date(a.completed_at));
}

export function getAssessment(id) {
  return readAll().find(a => a.id === id) || null;
}

export function saveAssessment({ orgId, type = 'moca', patientName, patientNotes, answers, result, educationYears, mode }) {
  const record = {
    id: newId(),
    org_id: orgId,
    type,
    patient_name: patientName || 'Anonymous patient',
    patient_notes: patientNotes || '',
    education_years: educationYears ?? null,
    mode: mode || 'provider',
    answers,
    result,
    completed_at: new Date().toISOString(),
  };
  const all = readAll();
  all.push(record);
  writeAll(all);
  return record;
}

export function deleteAssessment(id) {
  writeAll(readAll().filter(a => a.id !== id));
}
